import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ReactNode } from 'react';

type ContactAgentPageHeaderProps = {
  title: string;
  description: string;
  actions?: ReactNode;
  toolbar?: ReactNode;
  backTo?: string;
  showBack?: boolean;
  eyebrow?: string;
};

export function ContactAgentPageHeader({
  title,
  description,
  actions,
  toolbar,
  backTo = '/admin/contact-agent',
  showBack = true,
  eyebrow = 'Agente de contacto',
}: ContactAgentPageHeaderProps) {
  return (
    <div className='flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between'>
      <div>
        <p className='text-xs font-semibold uppercase tracking-[0.22em] text-muted-foreground'>
          {eyebrow}
        </p>
        <div className='mt-2 flex items-center gap-2'>
          {showBack ? (
            <Button variant='ghost' size='icon' asChild className='-ml-2 h-8 w-8'>
              <Link to={backTo} aria-label='Volver'>
                <ArrowLeft className='h-4 w-4' />
              </Link>
            </Button>
          ) : null}
          <h1 className='text-3xl font-semibold tracking-tight'>{title}</h1>
        </div>
        <p className='mt-2 max-w-2xl text-muted-foreground'>{description}</p>
        {toolbar ? <div className='mt-3'>{toolbar}</div> : null}
      </div>
      {actions ? <div className='flex flex-wrap gap-2'>{actions}</div> : null}
    </div>
  );
}

export function ContactAgentPage({ children }: { children: ReactNode }) {
  return <div className='mx-auto max-w-6xl space-y-8'>{children}</div>;
}
